import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const MessageReceiptSchema = withDefaults({
  type: 'message-receipt',
  fields: [
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'attribute',
      name: 'personId',
    },
    {
      kind: 'belongsTo',
      name: 'message',
      type: 'message',
      options: {
        async: false,
        inverse: 'messageReceipts',
      },
    },
    {
      kind: 'belongsTo',
      name: 'person',
      type: 'person',
      options: {
        async: false,
        inverse: 'person',
      },
    },
  ],
});

export default MessageReceiptSchema;
